import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import Stats from "./components/site/Stats";
import Problem from "./components/site/Problem";
import HowItWorks from "./components/site/HowItWorks";
import Services from "./components/site/Services";
import DualAudience from "./components/site/DualAudience";
import Pricing from "./components/site/Pricing";
import Testimonials from "./components/site/Testimonials";
import FAQ from "./components/site/FAQ";
import BookConsultation from "./components/site/BookConsultation";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";
import { siteFlags } from "./config/siteFlags";

const Landing = () => {  return (
    <div data-testid="landing-page" className="bg-[#F9F9F7] text-[#1C1C1A] font-sans-ui antialiased">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Problem />
        <HowItWorks />
        <Services />
        <DualAudience />
        <Pricing />
        {siteFlags.showTestimonials && <Testimonials />}
        <FAQ />
        <BookConsultation />
      </main>
      <Footer />
    </div>
  );
};

const ContactPage = () => (
  <div data-testid="contact-page" className="bg-[#F9F9F7] text-[#1C1C1A] font-sans-ui antialiased">
    <Navbar />
    <main className="pt-16">
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#1C1C1A",
            border: "1px solid rgba(28, 28, 26, 0.12)",
            borderRadius: "2px",
            fontFamily: "Outfit, system-ui, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
